import { useLayoutEffect, useRef } from 'react';

const useSyncedAnimations = () => {
  const ref = useRef(null);

  useLayoutEffect(() => {
    ref.current?.getAnimations?.({ subtree: true }).forEach((animation) => {
      animation.startTime = 0;
    });
  }, []);

  return ref;
};

export default useSyncedAnimations;
